import { Grid, Card, CardContent, Box } from "@mui/material"
import { LoginCardStyles, LoginPageStyles, LogoStyles} from "./styles/LoginPageStyles"
import Login from "./Login"
import logo from "../../resources/images/precipartLogoLight.png"

function LoginPage() {

    return (
        <>
            <Grid container justifyContent="center" sx={LoginPageStyles}>
                <Card sx={LoginCardStyles} elevation={15}>
                    <CardContent align="center">
                        <Box
                            component="img"
                            alt="Logo"
                            src={logo}
                            sx={LogoStyles}
                        />
                        <Login />
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}

export default LoginPage
